export function isEmail(str: string) {
  const regex = /^\S+@\S+\.\S+$/;
  return regex.test(str);
}
